import { TranslationLanguage } from '@privanot/shared-models';

const LANGUAGE_STORAGE_KEY = 'lang';
const DEFAULT_LANGUAGE = TranslationLanguage.ENGLISH;

export function getStoredLanguage(): string {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) ?? DEFAULT_LANGUAGE;
}

export function setStoredLanguage(lang: string): void {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
}
